export default __webpack_public_path__ + "static/media/dots.01d6ec46.jpg";